import { gql } from '@apollo/client';

export const toggleArticleInspire = gql`
  mutation toggleArticleInspire($articleId: ID!) {
    toggleArticleInspire(articleId: $articleId)
  }
`;
